/**
 * client
 *
 * Legacy browser Supabase client re-export.
 *
 * Primary responsibilities:
 * - Preserve existing import paths
 * - Route all browser Supabase access to one shared client
 *
 * Dependencies:
 * - lib/supabase/browser-client
 */

export { supabase, createClient } from '@/lib/supabase/browser-client'
